module.exports = __webpack_public_path__ + "static/img/antibody_600x450.2062dcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vaccinetest/antibody_600x450.jpg
// module id = 9EGh
// module chunks = 0